import React, { useState, useEffect } from 'react';
import PhoneInputProps from './PhoneInput.types';
import styles from './PhoneInput.module.scss';
import Input from '../Input/Input';

const PhoneInput = ({
  onChange = () => {},
  dataPointer,
  id,
  invalid = false,
  dataCy = 'phoneInput',
  label,
  errorMsgHolderId,
  countryCodeDefault = '+44',
  phoneDefault = '',
  phonePlaceholder,
  countryCodePlaceholder,
}: PhoneInputProps) => {
  const [countryCode, setCountryCode] = useState<string>(countryCodeDefault);
  const [phoneNumber, setPhoneNumber] = useState<string>(phoneDefault);

  const handleCountryCode = (e: React.FormEvent<HTMLInputElement>) => {
    const target = e.target as HTMLSelectElement;
    const countryCodeValue = target.value;
    setCountryCode(countryCodeValue);
  };

  const handlePhoneNumber = (e: React.FormEvent<HTMLInputElement>) => {
    const target = e.target as HTMLSelectElement;
    const phoneNumberValue = target.value;
    setPhoneNumber(phoneNumberValue);
  };

  const populateCountryCode = () => {
    if (!countryCode) setCountryCode(countryCodeDefault);
  };

  useEffect(() => {
    if (countryCode && phoneNumber) {
      const omitZeroAndSpaces = phoneNumber.replace(/^0+|\s+/g, '');
      const telephoneString = `${countryCode}${omitZeroAndSpaces}`;

      const fakeEvent = {
        currentTarget: {
          value: telephoneString,
          getAttribute: (value: string) => {
            if (value === 'type') return 'change';
            if (value === 'data-pointer') return dataPointer;
            return null;
          },
        },
      } as React.ChangeEvent<HTMLInputElement>;

      onChange(fakeEvent);
    }
  }, [countryCode, phoneNumber]);

  return (
    <div data-cy={dataCy}>
      <div className={styles.phoneInput} aria-errormessage={errorMsgHolderId}>
        <Input
          dataCy={`${dataCy}ContryCode`}
          className={styles.small}
          placeholder={countryCodePlaceholder}
          onChange={handleCountryCode}
          data-pointer={dataPointer}
          value={countryCode}
          controlled
          invalid={invalid}
          autoComplete='new-password'
          onFocus={populateCountryCode}
          label={label}
        />

        <Input
          dataCy={`${dataCy}PhoneNumber`}
          placeholder={phonePlaceholder}
          onChange={handlePhoneNumber}
          data-pointer={dataPointer}
          value={phoneNumber}
          id={id}
          controlled
          invalid={invalid}
          className={styles.input}
          label={label}
        />
      </div>
    </div>
  );
};

export default PhoneInput;
